(function () {
  var OPEN = 'alshaya-bundle-open';
  var BUNDLE = '.classic-bundle-swatch-circle, [class*="classic-bundle"], .usd-bundle-products-vertical';
  var MENU = '.zy-select-items, [class*="Select__ZySelectItemsWrapper"]';
  var TRIGGER = '.ushopaid-custom-selector, .zy-current-item';
  var PDP_PICKER = 'variant-picker, .product-info__variant-picker, .variant-picker, sticky-atc-variant, .sticky-atc-variant-select';
  var pdpState = null;
  var guardingPdp = false;
  var lockedScrollY = 0;
  var guardTimer = null;

  function toEl(node) {
    return node && node.nodeType === 3 ? node.parentElement : node;
  }

  function inBundle(node) {
    node = toEl(node);
    return !!(node && node.closest && node.closest(BUNDLE));
  }

  function inPdpPicker(node) {
    node = toEl(node);
    return !!(node && node.closest && node.closest(PDP_PICKER));
  }

  function findTrigger(node) {
    node = toEl(node);
    if (!node || !node.closest) return null;
    var trigger = node.closest(TRIGGER);
    if (trigger && trigger.closest('.zy-select-item')) return null;
    return trigger;
  }

  function findMenu(trigger) {
    if (!trigger) return null;
    var next = trigger.nextElementSibling;
    if (next && next.matches && next.matches(MENU)) return next;
    var parent = trigger.parentElement;
    return parent ? parent.querySelector(MENU) : null;
  }

  function capturePdp() {
    var form = document.querySelector('form[id^="product-form-"]') || document.querySelector('.product-info form');
    var idInput = form && form.querySelector('[name="id"]');
    return {
      id: idInput ? String(idInput.value || '') : '',
      url: location.pathname + location.search,
      radios: Array.prototype.slice.call(document.querySelectorAll('.product-info input[type="radio"]:checked, variant-picker input[type="radio"]:checked')),
      selects: Array.prototype.map.call(document.querySelectorAll('.product-info select, .sticky-atc-variant-select, variant-picker select'), function (el) {
        return { el: el, value: el.value };
      })
    };
  }

  function rememberPdp() {
    if (guardingPdp) return;
    pdpState = capturePdp();
  }

  function restorePdp() {
    if (!pdpState) return;
    var form = document.querySelector('form[id^="product-form-"]') || document.querySelector('.product-info form');
    var idInput = form && form.querySelector('[name="id"]');
    if (idInput && pdpState.id && idInput.value !== pdpState.id) {
      idInput.value = pdpState.id;
    }
    pdpState.radios.forEach(function (el) {
      if (el && document.contains(el) && !el.checked) el.checked = true;
    });
    pdpState.selects.forEach(function (item) {
      if (item.el && document.contains(item.el) && item.el.value !== item.value) {
        item.el.value = item.value;
      }
    });
    if (pdpState.url && location.pathname + location.search !== pdpState.url) {
      history.replaceState(history.state, '', pdpState.url);
    }
    if (Math.abs((window.scrollY || window.pageYOffset) - lockedScrollY) > 1) {
      window.scrollTo(0, lockedScrollY);
    }
  }

  function startPdpGuard() {
    rememberPdp();
    guardingPdp = true;
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    if (guardTimer) clearTimeout(guardTimer);
    restorePdp();
    [0, 30, 80, 160, 320, 600].forEach(function (ms) {
      setTimeout(restorePdp, ms);
    });
    guardTimer = setTimeout(function () {
      guardingPdp = false;
      guardTimer = null;
    }, 800);
  }

  var nativeFocus = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function (options) {
    if (guardingPdp && this.closest && this.closest(PDP_PICKER)) {
      return nativeFocus.call(this, Object.assign({}, options || {}, { preventScroll: true }));
    }
    return nativeFocus.apply(this, arguments);
  };

  var nativeScrollIntoView = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function () {
    if (guardingPdp && this.closest && (this.closest(PDP_PICKER) || this.closest('.product-info'))) {
      return;
    }
    return nativeScrollIntoView.apply(this, arguments);
  };

  window.addEventListener(
    'scroll',
    function () {
      if (!guardingPdp) return;
      if (Math.abs((window.scrollY || window.pageYOffset) - lockedScrollY) > 1) {
        window.scrollTo(0, lockedScrollY);
      }
    },
    true
  );

  document.addEventListener(
    'focus',
    function (event) {
      if (!guardingPdp) return;
      if (inPdpPicker(event.target)) {
        event.target.blur();
        window.scrollTo(0, lockedScrollY);
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      if (!guardingPdp) return;
      if (inPdpPicker(event.target) || (event.target && event.target.name === 'id' && !inBundle(event.target))) {
        event.stopImmediatePropagation();
        restorePdp();
      }
    },
    true
  );

  document.addEventListener(
    'variant:change',
    function (event) {
      if (guardingPdp) {
        event.stopImmediatePropagation();
        restorePdp();
        return;
      }
      rememberPdp();
    },
    true
  );

  document.addEventListener(
    'product:rerender',
    function (event) {
      if (guardingPdp) {
        event.stopImmediatePropagation();
        restorePdp();
      }
    },
    true
  );

  function closeAll() {
    document.querySelectorAll('.' + OPEN).forEach(function (menu) {
      menu.classList.remove(OPEN);
    });
    document.querySelectorAll('[data-alshaya-elevated]').forEach(function (node) {
      node.style.removeProperty('z-index');
      node.removeAttribute('data-alshaya-elevated');
    });
  }

  function elevate(menu) {
    var card = menu.closest('.usd-bundle-product-item-wrapper, .usd-bundle-product-item-vertical');
    if (card) {
      card.style.setProperty('z-index', '80', 'important');
      card.setAttribute('data-alshaya-elevated', 'true');
    }
  }

  function pinMenu(menu, trigger) {
    trigger = trigger || menu.previousElementSibling;
    if (!trigger) return;
    elevate(menu);

    var rect = trigger.getBoundingClientRect();
    var rtl = document.documentElement.getAttribute('dir') === 'rtl';
    var gap = 6;
    var pad = 8;
    var height = menu.offsetHeight || menu.scrollHeight || 168;
    var button = document.querySelector('.usd-bundle-submit-btn');
    var floor = button ? button.getBoundingClientRect().top - pad : window.innerHeight - pad;
    var top = Math.round(rect.bottom + gap);
    if (top + height > floor) top = Math.round(rect.top - height - gap);
    if (top < pad) top = pad;

    menu.style.position = 'fixed';
    menu.style.top = top + 'px';
    menu.style.bottom = 'auto';
    menu.style.zIndex = '2147483000';
    menu.style.pointerEvents = 'auto';
    if (rtl) {
      menu.style.right = Math.round(window.innerWidth - rect.right) + 'px';
      menu.style.left = 'auto';
    } else {
      menu.style.left = Math.round(rect.left) + 'px';
      menu.style.right = 'auto';
    }
  }

  function openMenu(menu, trigger) {
    menu.classList.add(OPEN);
    pinMenu(menu, trigger);
    requestAnimationFrame(function () {
      pinMenu(menu, trigger);
    });
  }

  function resetBundlePrices(target) {
    var card = target && target.closest && target.closest('.usd-bundle-product-item-vertical, .usd-bundle-product-item-wrapper');
    var scope = card || document.querySelector('.usd-bundle-products-vertical') || document;
    scope.querySelectorAll('.ush-bpi-price, .ush-bpi-compare-price').forEach(function (el) {
      el.removeAttribute('data-price');
      el.removeAttribute('data-native-painted');
      el.removeAttribute('data-currency-price');
    });
    var wrap = document.querySelector('.alshaya-bundle-atc-prices');
    if (wrap) wrap.removeAttribute('data-alshaya-atc');
  }

  function refreshBundleCurrency() {
    [50, 150, 320, 600, 1000].forEach(function (ms) {
      setTimeout(function () {
        applyBundleCurrency();
        if (window.NativeCurrency && typeof window.NativeCurrency.refresh === 'function') {
          window.NativeCurrency.refresh();
        }
      }, ms);
    });
  }

  rememberPdp();

  document.addEventListener(
    'pointerdown',
    function (event) {
      var target = toEl(event.target);
      if (target && target.closest && target.closest('.zy-select-item') && inBundle(target)) {
        startPdpGuard();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var target = toEl(event.target);
      if (!target || !target.closest) return;

      if (guardingPdp && inPdpPicker(target) && !inBundle(target)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        restorePdp();
        return;
      }

      if (target.closest('.zy-select-item') && inBundle(target)) {
        startPdpGuard();
        resetBundlePrices(target);
        refreshBundleCurrency();
        setTimeout(closeAll, 280);
        return;
      }

      var trigger = findTrigger(target);
      if (trigger && inBundle(trigger)) {
        var menu = findMenu(trigger);
        if (!menu) return;
        event.preventDefault();
        event.stopPropagation();
        var alreadyOpen = menu.classList.contains(OPEN);
        closeAll();
        if (!alreadyOpen) openMenu(menu, trigger);
        return;
      }

      if (!target.closest(MENU)) closeAll();
    },
    true
  );

  window.addEventListener('resize', function () {
    document.querySelectorAll('.' + OPEN).forEach(function (menu) {
      pinMenu(menu);
    });
  });

  var applying = false;
  var relocatingBundle = false;
  var bundleMoveCount = 0;
  var bundleMoveWindow = 0;

  function pdpBundleSlot() {
    return document.getElementById('alshaya-pdp-bundle');
  }

  function inCartDrawer(node) {
    return !!(node && node.closest && node.closest('cart-drawer, #cart-drawer'));
  }

  function isBundleNode(node) {
    if (!node || node.nodeType !== 1 || !node.matches) return false;
    if (node.matches('.classic-bundle-swatch-circle, .usd-bundle-products-vertical, .usd-bundle-title, .usd-bundle-submit-btn')) return true;
    return !!(node.querySelector && node.querySelector('.classic-bundle-swatch-circle, .usd-bundle-products-vertical, .usd-bundle-submit-btn'));
  }

  function bundleRoot(node) {
    if (!node || node.nodeType !== 1) return null;
    var card = node.closest && node.closest('.classic-bundle-swatch-circle');
    if (card && !card.matches('cart-drawer, #cart-drawer, .product-info, body, html')) return card;
    var vertical = (node.closest && node.closest('.usd-bundle-products-vertical')) || (node.matches && node.matches('.usd-bundle-products-vertical') ? node : null);
    if (!vertical) return node.matches && isBundleNode(node) ? node : null;
    var parent = vertical.parentElement;
    if (parent && inCartDrawer(parent) && parent.querySelector('.usd-bundle-title, .usd-bundle-submit-btn') && !parent.matches('cart-drawer, #cart-drawer, .cart-drawer__inner, .cart-drawer__line-items')) {
      return parent;
    }
    return vertical;
  }

  function relocateBundleToPdp() {
    if (relocatingBundle) return;
    var slot = pdpBundleSlot();
    if (!slot) return;
    if (slot.querySelector('.classic-bundle-swatch-circle, .usd-bundle-products-vertical, .usd-bundle-submit-btn')) return;

    var nodes = document.querySelectorAll('.classic-bundle-swatch-circle, .usd-bundle-products-vertical, .usd-bundle-submit-btn');
    var root = null;
    for (var i = 0; i < nodes.length; i++) {
      if (!inCartDrawer(nodes[i])) continue;
      root = bundleRoot(nodes[i]);
      if (root && inCartDrawer(root) && !root.matches('cart-drawer, #cart-drawer')) break;
      root = null;
    }
    if (!root) return;

    var now = Date.now();
    if (now - bundleMoveWindow > 2000) {
      bundleMoveWindow = now;
      bundleMoveCount = 0;
    }
    bundleMoveCount += 1;
    if (bundleMoveCount > 6) return;

    relocatingBundle = true;
    try {
      slot.appendChild(root);
    } finally {
      relocatingBundle = false;
    }
  }

  (function interceptCartBundleMount() {
    var appendChild = Node.prototype.appendChild;
    var insertBefore = Node.prototype.insertBefore;
    Node.prototype.appendChild = function (child) {
      var slot = pdpBundleSlot();
      if (slot && this !== slot && !slot.contains(this) && inCartDrawer(this) && isBundleNode(child)) {
        return appendChild.call(slot, child);
      }
      return appendChild.call(this, child);
    };
    Node.prototype.insertBefore = function (child, ref) {
      var slot = pdpBundleSlot();
      if (slot && this !== slot && !slot.contains(this) && inCartDrawer(this) && isBundleNode(child)) {
        return appendChild.call(slot, child);
      }
      return insertBefore.call(this, child, ref);
    };
  })();

  function currencyLabel() {
    if (window.NativeCurrency && typeof window.NativeCurrency.config === 'function') {
      var cfg = window.NativeCurrency.config();
      if (cfg) {
        var country = cfg.country;
        var map = cfg.marketCurrencyMap || {};
        var code = (country && map[country]) || cfg.presentmentCurrency || cfg.shopCurrency;
        if (code === 'SAR') return '__SAR__';
        if (code === 'KWD') {
          var lang = (document.documentElement.lang || '').toLowerCase();
          return lang.indexOf('ar') === 0 ? 'د.ك.' : 'K.D.';
        }
      }
    }
    var fromHtml = document.documentElement.getAttribute('data-alshaya-currency');
    if (fromHtml) return fromHtml;
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('ar') === 0 ? 'د.ك.' : 'K.D.';
  }

  function isoPrefixed(raw) {
    return /^(KWD|BHD|SAR|AED|QAR|QR|OMR|EGP|JOD|IQD|GBP)\s/i.test(String(raw || '').trim());
  }

  function decorateMoney(el) {
    if (!el) return;
    if (el.getAttribute('data-native-painted')) return;
    if (el.querySelector('.f-price__currency--sar, .sar-symbol')) return;
    var extras = el.querySelectorAll('.alshaya-currency');
    for (var i = 1; i < extras.length; i++) extras[i].remove();
    var money = el.classList.contains('money') ? el : el.querySelector('.money') || el;
    var raw = bundleMoneyText(el);
    if (!raw) return;
    var label = currencyLabel();
    var alreadyLocalized =
      !isoPrefixed(raw) &&
      (label === '__SAR__'
        ? /⃁|\uE900|SAR/i.test(raw)
        : raw.indexOf(label) !== -1);
    if (alreadyLocalized && el.querySelector('.alshaya-currency')) return;
    if (alreadyLocalized && !isoPrefixed(raw)) return;
    var major = parsePrice(raw);
    if (!major) return;
    setBundlePriceText(money, major);
    if (money !== el) {
      Array.prototype.slice.call(el.childNodes).forEach(function (node) {
        if (node.nodeType === 3) {
          node.textContent = node.textContent.replace(/KWD|BHD|SAR|AED|QAR|OMR|K\.D\.?/gi, '');
        }
      });
    }
  }

  function parsePrice(text) {
    var source = String(text || '')
      .replace(/[٠١٢٣٤٥٦٧٨٩]/g, function (digit) {
        return String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit));
      })
      .replace(/٫/g, '.')
      .replace(/٬/g, '')
      .replace(/,/g, '')
      .replace(/[^\d.]/g, '');
    var integerPart = source.split('.')[0] || '';
    if (integerPart.length > 6) return 0;
    var n = parseFloat(source);
    if (!isFinite(n) || n <= 0 || n > 99999) return 0;
    return n;
  }

  function bundleMoneyText(el) {
    var money = el.classList.contains('money') ? el : el.querySelector('.money');
    return ((money || el).textContent || '').replace(/\s+/g, ' ').trim();
  }

  function subunit() {
    var cfg = window.NativeCurrency && typeof window.NativeCurrency.config === 'function' ? window.NativeCurrency.config() : null;
    var n = cfg && Number(cfg.shopSubunit);
    return n > 0 ? n : 100;
  }

  function presentmentCode() {
    var cfg = window.NativeCurrency && typeof window.NativeCurrency.config === 'function' ? window.NativeCurrency.config() : null;
    if (cfg && cfg.presentmentCurrency) return cfg.presentmentCurrency;
    if (cfg && cfg.shopCurrency) return cfg.shopCurrency;
    return 'KWD';
  }

  document.addEventListener(
    'change',
    function (event) {
      var target = toEl(event.target);
      if (target && inBundle(target) && !inPdpPicker(target)) {
        resetBundlePrices(target);
        refreshBundleCurrency();
      }
    },
    true
  );

  function stampOriginal(el) {
    if (!el) return;
    if (el.querySelector('.f-price__currency--sar, .sar-symbol')) return;
    if (el.getAttribute('data-native-painted')) return;
    var existing = Number(el.getAttribute('data-price'));
    var stampedOk = Number.isFinite(existing) && existing > 0 && existing <= 1e9;
    if (stampedOk) return;
    var major = parsePrice(bundleMoneyText(el));
    if (!major) return;
    el.setAttribute('data-currency-price', '');
    el.setAttribute('data-price', String(Math.round(major * subunit())));
    el.setAttribute('data-presentment-currency', presentmentCode());
  }

  function centsOf(el) {
    if (!el) return 0;
    stampOriginal(el);
    var cents = Number(el.getAttribute('data-price'));
    if (Number.isFinite(cents) && cents > 0 && cents <= 1e9) return cents;
    if (el.querySelector('.f-price__currency--sar, .sar-symbol')) return 0;
    return Math.round(parsePrice(bundleMoneyText(el)) * subunit());
  }

  function formatPrice(n) {
    if (!isFinite(n) || n <= 0 || n > 99999) return '';
    var label = currencyLabel();
    if (label === '__SAR__') return n.toFixed(2);
    return n.toFixed(2) + ' ' + label;
  }

  function setBundlePriceText(el, major) {
    var label = currencyLabel();
    if (label === '__SAR__') {
      el.innerHTML = Number(major).toFixed(2) + ' <span class="f-price__currency f-price__currency--sar" aria-label="SAR"></span>';
      return;
    }
    el.textContent = formatPrice(major);
  }

  function updateAtcPrices() {
    var btn = document.querySelector('.usd-bundle-submit-btn');
    if (!btn) return;

    var saleCents = 0;
    var compareCents = 0;
    var hasCompare = false;
    document.querySelectorAll('.usd-bundle-product-item-vertical').forEach(function (card) {
      var priceEl = card.querySelector('.ush-bpi-price');
      var compareEl = card.querySelector('.ush-bpi-compare-price');
      var priceVal = centsOf(priceEl);
      saleCents += priceVal;
      if (compareEl) {
        var compareVal = centsOf(compareEl);
        if (compareVal > 0) {
          compareCents += compareVal;
          hasCompare = true;
          return;
        }
      }
      compareCents += priceVal;
    });

    if (saleCents <= 0 || saleCents > 1e9) return;

    btn.querySelectorAll('.money').forEach(function (el) {
      if (el.closest('.alshaya-bundle-atc-prices')) return;
      var prev = el.previousSibling;
      if (prev && prev.nodeType === 3) {
        prev.textContent = prev.textContent.replace(/\s*·\s*$/, ' ');
      }
      el.style.display = 'none';
    });

    var wrap = btn.querySelector('.alshaya-bundle-atc-prices');
    if (!wrap) {
      wrap = document.createElement('span');
      wrap.className = 'alshaya-bundle-atc-prices';
      btn.appendChild(wrap);
    }

    var key = String(saleCents) + '|' + String(compareCents);
    if (wrap.getAttribute('data-alshaya-atc') === key) return;
    wrap.setAttribute('data-alshaya-atc', key);
    wrap.textContent = '';

    var saleMajor = saleCents / subunit();
    var compareMajor = compareCents / subunit();
    if (!isFinite(saleMajor) || saleMajor > 99999) return;
    var saleText = formatPrice(saleMajor);
    if (!saleText) return;
    var saleSpan = document.createElement('span');
    saleSpan.className = 'alshaya-bundle-atc-sale';
    saleSpan.setAttribute('data-currency-price', '');
    saleSpan.setAttribute('data-price', String(saleCents));
    saleSpan.setAttribute('data-presentment-currency', presentmentCode());
    setBundlePriceText(saleSpan, saleMajor);
    wrap.appendChild(saleSpan);

    if (hasCompare && compareCents > saleCents + 1) {
      var compareSpan = document.createElement('span');
      compareSpan.className = 'alshaya-bundle-atc-compare';
      compareSpan.setAttribute('data-currency-price', '');
      compareSpan.setAttribute('data-price', String(compareCents));
      compareSpan.setAttribute('data-presentment-currency', presentmentCode());
      setBundlePriceText(compareSpan, compareMajor);
      wrap.appendChild(compareSpan);
    }

    if (window.NativeCurrency && typeof window.NativeCurrency.refresh === 'function') {
      window.NativeCurrency.refresh();
    }
  }

  function applyBundleCurrency() {
    if (applying) return;
    if (window.NativeCurrency && window.NativeCurrency.isPainting && window.NativeCurrency.isPainting()) return;
    applying = true;
    try {
      document.querySelectorAll('.ush-bpi-price, .ush-bpi-compare-price').forEach(function (el) {
        stampOriginal(el);
        decorateMoney(el);
      });
      updateAtcPrices();
    } finally {
      applying = false;
    }
  }

  applyBundleCurrency();
  relocateBundleToPdp();
  [300, 800, 1600, 3000].forEach(function (ms) {
    setTimeout(function () {
      relocateBundleToPdp();
      applyBundleCurrency();
    }, ms);
  });
  var currencyObserver = new MutationObserver(function () {
    relocateBundleToPdp();
    applyBundleCurrency();
  });
  currencyObserver.observe(document.body, { childList: true, subtree: true });
})();
